import { useEffect } from 'react';
import { useTour } from '../../hooks/useTour';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';

/**
 * Component that automatically starts the tour for first-time users
 * when they land on the forecast page
 */
export const AutoStartTour: React.FC = () => {
  const { startTour, hasCompletedTour } = useTour();
  const { user, isLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Only auto-start the tour if:
    // 1. User is logged in
    // 2. User hasn't completed the tour before
    // 3. We're on the forecast page (main page)
    // 4. Auth is not loading
    if (user && !hasCompletedTour && location.pathname === '/forecast' && !isLoading) {
      // Small delay to ensure the page is fully rendered
      const timer = setTimeout(() => {
        startTour();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user, hasCompletedTour, location.pathname, isLoading, startTour]);

  // This component doesn't render anything
  return null;
};

